import React, { Component } from 'react'

export default class Footer extends Component {
    render() {
        return (
           <div>
  <footer className="main-footer">
    <strong>Copyright © 2025 AICEE </strong>
    All rights reserved.
    <div className="float-right d-none d-sm-inline-block">
      
    </div>
  </footer>
</div>

        )
    }
}
